export default __webpack_public_path__ + "static/media/sign.8a52fd44.png";